import { gql } from "@apollo/client";

export const GET_DASHBOARD_DATA = gql`
  query GetDashboardData($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      name
      role
      company_id
      company {
        name
        organization_balance {
          total_allocated
          total_loaded_to_cards
          total_loaded_to_virtual_cards
          available_balance
        }
      }
    }
    physical_cards(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      card_name
      card_number_last_four
      status
      current_balance
      available_balance
      expiry_month
      expiry_year
    }
    virtual_cards(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      card_name
      card_type
      card_number_last_four
      status
      current_balance
      spending_limit
      expiry_date
    }
    transactions(
      where: {
        _or: [
          { physical_card: { user_id: { _eq: $userId } } }
          { virtual_card: { user_id: { _eq: $userId } } }
        ]
      }
      order_by: { processed_at: desc }
      limit: 5
    ) {
      id
      merchant_name
      amount
      status
      processed_at
      physical_card {
        card_name
        card_number_last_four
      }
      virtual_card {
        card_name
        card_number_last_four
      }
    }
  }
`;
